import { Component, OnInit, TemplateRef, ChangeDetectorRef, ViewChild, Input, Output, EventEmitter, ElementRef, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import * as jwt_decode from 'jwt-decode';
import { DatePipe } from '@angular/common'
import { FormBuilder, FormControl } from '@angular/forms';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { FormsService } from '../../eSignature/services/forms.service';
import { SettingService } from '../../settings/services/settingService/setting.service';
import { CreateProjectsComponent } from 'src/app/middleware/common/createProjects/createProjects.component';
import { ProjectTempType } from '../../eSignature/services/form.enum';
import { UploadAIDocuments } from 'src/app/middleware/common/uploadAIDocuments/uploadAIDocuments.component';
import { interval, Observable, Subscription } from 'rxjs';
import { NTAComponent } from 'src/app/middleware/shared/common/nta/nta.component';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { AttachFilesComponent } from 'src/app/middleware/shared/common/attachFiles/attachFiles.component';
import { ConfirmDialogChangeComponent } from 'src/app/middleware/common/reusableComponents/confirm-dialog-change/confirm-dialog-change.component';
const FileSaver = require('file-saver');

export interface State {
  name: string;
  fax: string;
  role: string;
  pic: string;
}

@Component({
  selector: 'app-pdpm-dashboard',
  templateUrl: './pdpm-dashboard.component.html',
  styleUrls: ['./pdpm-dashboard.component.scss']
})

export class PDPMDashboardComponent implements OnInit {
      colors = [
  { color: "#e6194b" }, // Red
  { color: "#3cb44b" }, // Green
  { color: "#ffe119" }, // Yellow
  { color: "#4363d8" }, // Blue
  { color: "#f58231" }, // Orange
  { color: "#911eb4" }, // Purple
  { color: "#46f0f0" }, // Cyan
  { color: "#f032e6" }, // Magenta
  { color: "#bcf60c" }, // Lime
  { color: "#fabebe" }, // Light Pink
  { color: "#008080" }, // Teal
  { color: "#e6beff" }, // Lavender
  { color: "#9a6324" }, // Brown // Cream
  { color: "#800000" }, // Maroon
  { color: "#aaffc3" }, // Mint
  { color: "#808000" }, // Olive // Peach
  { color: "#000075" }, // Navy Blue
  { color: "#808080" }  // Gray
];
selectedItems: any[] = [];
  selectAll: boolean = false;
  selectedRows: any[] = [];
  selectedListType: string = "MCA";
  listTitle: String = "";
  databaseId: string;
  organizationId: string;
  currentUser: any;
  userId: string = "";
  OfficeIDList: any = [];
  roleIdList: any;
  myOfficeID: any;
  currentImportantFavoriteElement: any;
  responseHolder: any = [] = [];
  stageProcessList: any = [] = [];
  medicalStages: any = [] = [];
  searchResident: string = "";
  searchResidentHipps: string = "";
  activeMCAResidents: any = [] = [];
  displayedColumns: string[] = [
    'resident', 'losDay', 'payer', 'hipps', 'careLevel',
    'ptot', 'nursing', 'nta', 'rate', 'alert', 'documents'
  ];
  hippsResidents: any = [] = [];
  selectedprocessStageID: number = 0;
  openDocumentViewers: boolean = false;

  //   [{
  //     name: 'Janet Holloway', mrn: '102938', room: '205A', losDay: 14,
  //     payer: 'Aetna', hipps: 'ZBDA0', careLevel: 'L1',
  //     pt: 2.1, ot: 1.8, slp: 0.9, nursing: 3.2, nta: 2.4, rate: 425.50,
  //     alert: 'Authorization expires in 3 days', alertClass: 'blue',
  //     docTitle: 'MDS Assessment Package'
  //   },
  //   {
  //     name: 'Luis Porter', mrn: '554420', room: '312B', losDay: 3,
  //     payer: 'Humana', hipps: 'ZBDA0', careLevel: 'UNK00',
  //     pt: 1.5, ot: 1.2, slp: 0, nursing: 2.8, nta: 1.9, rate: 385.75,
  //     alert: 'Care plan update due', alertClass: 'yellow',
  //     docTitle: 'Standard Review Package'
  //   },
  //   {
  //     name: 'Maria Rodriguez', mrn: '889456', room: '118C', losDay: 8,
  //     payer: 'UnitedHealth', hipps: 'ZBDA0', careLevel: 'L4',
  //     pt: 1.8, ot: 1.4, slp: 0.5, nursing: 2.9, nta: 2.1, rate: 398.25,
  //     alert: 'Assessment overdue by 2 days', alertClass: 'red',
  //     docTitle: 'Urgent Assessment Package'
  //   }
  // ];

  CoreShowName: string = '';
  params: string = "";
  getassign: any;
  SendButtonDisabled: boolean = false;
  NormalContacts: any = [];
  SharedContacts: any = [];
  MatchingRole: any = [];
  openDocumentDetail: boolean = false;
  selectedDocument: any;
  transactionID: number = 0;
  @ViewChild('Input') InputFile: ElementRef;
  selectedFilePlaceHolder: string = '';
  selectedFolderId: string = '';
  selectedFile: string = '';
  formData: FormData;
  attachedToCoreList: any = [] = [];
  searchName: string = '';
  timeout = null;
  menuModulesList: any = [] = [];
  CorefolderID: number = 0;
  addUpdateParticipantList: any = [] = [];
  showAddButton = true;
  stateCtrl = new FormControl();
  filteredStates: Observable<State[]>;
  folderID: number = 0;
  spinner: boolean = false;
  sendFrom: string = "TypeofParticipant";
  getPDPMStagesList: any = [] = [];
  showNoRecord: boolean = false;
  clickEventsubscriptionCore: Subscription;
  admissionDate: any;
  dischargeDate: any;
  losDayCalculation: any;
  runFileAi: boolean = false;
  subscription: Subscription;
  nursingText: any;
  isArchived:boolean=false;

  constructor( private dialogRef: MatDialogRef<NTAComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private formBuilder: FormBuilder, private router: Router, private dialog: MatDialog, private _dataSharingService: DataSharingService,
    private cdr: ChangeDetectorRef, private reusableClass: ReusableClasses, private encryptionAlgo: EncryptionService,
    private formsService: FormsService, public datepipe: DatePipe, private statusConstant: StatusConstant,
    private toastr: ToastrService, private taskService: SettingService,
    private loaderService: LoaderService) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    this.currentUser = jwt_decode(token);
    var offices = [];
    offices = JSON.parse(sessionStorage.getItem('officeList'));
    if (offices.length > 0) {
      offices.forEach(oe => {
        this.OfficeIDList.push(oe.officeID)
        if (oe.isMyoffice == true)
          this.myOfficeID = oe.officeID;
      });
    }



  }

  ngOnInit(): void {
    this.getPDPMStageslist();
    this.subscription = interval(10000).subscribe(() => {
      if (this.runFileAi == true) {
        this.getPDPMCores(0, this.selectedListType);
      }
    });

    this.menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var SelectedCore = [];

    SelectedCore = this.menuModulesList.filter(x => x.mainModuleName == 'Core');
    if (SelectedCore.length > 0) {
      this.CoreShowName = SelectedCore[0].orgModuleName;
      this.folderID = SelectedCore[0].folderID;
    }

    this.clickEventsubscriptionCore = this._dataSharingService.getSaveUserForCore().subscribe(() => {
      this.getPDPMCores(0, this.selectedListType);
    });

    this.getPDPMCores(0, this.selectedListType);
  }

  ngOnDestroy() {
    this.runFileAi = false;
    if (this.clickEventsubscriptionCore) {
      this.clickEventsubscriptionCore.unsubscribe();
    }
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  bindTitle(type: string) {
    this.selectedRows=[];
     this.selectAll = false;
    if (type == "MCA") {
      this.selectedListType == "MCA";
      this.listTitle = "All Active Medicare";
      this.isArchived=false;
    }else if (type == "MEDICAID") {
      this.selectedListType = "MEDICAID";
      this.listTitle = "All Active MEDICAID";
      this.isArchived=false;
    }
     else if (type == "HIPPS") {
      this.selectedListType = "HIPPS";
      this.listTitle = "Other with HIPPS";
      this.isArchived=false;
    }
    else if (type == "UnAssigned") {
      this.selectedListType = "UnAssigned";
      this.listTitle = "Not Assigned Yet";
      this.isArchived=false;
    }
    else if (type == "Archived") {
      this.selectedListType = "Archived";
      this.listTitle = "All Archived";
      this.isArchived=true;
    }
  }


  signNow(token: any, doc: any, core: any) {
    this.params = decodeURIComponent(token);
    const decryptedTokenString = this.encryptionAlgo.get(this.reusableClass.encryptionKey, this.params);
    let decryptedToken = JSON.parse(decryptedTokenString)
    let objModel = {
      "OfficeID": decryptedToken.OfficeID,
      "IsReadOnlyFromSentPage": false,
      "ProjectID": decryptedToken.FormID,
      "FormID": decryptedToken.FormID,
      "CoreID": Number(core.coreID),
      "CorePlaceholderID": doc.placeholderID,
      "DocumentHtmls": "",
      "participantJsonList": "",
      "documentFolderID": doc.documentFolderID,
      "Email": "",
      "DatabaseID": decryptedToken.DatabaseID,
      "OrganizationID": decryptedToken.OrganizationID,
      "UserID": decryptedToken.UserID,
      "userEmailFromWhereSignNowCame": sessionStorage.getItem('email')
    };
    let jsonStringToken = JSON.stringify(objModel);
    token = this.encryptionAlgo.set(this.reusableClass.encryptionKey, jsonStringToken);
    token = encodeURIComponent(token);

    //1pdf 2 tabular 3 html{
    let url = '';
    if (doc.formType == 1)
      url = window.location.href.split(window.location.pathname)[0] + "/request/signature?token=" + token + "&type=1";
    else if (doc.formType == 2)
      url = window.location.href.split(window.location.pathname)[0] + "/request/tabularsignature?token=" + token + "&type=1";
    window.open(url, "_blank");
  }



  creatProject(document, core) {
    this.getassign = document;
    this.SendButtonDisabled = false;
    const dialogRef = this.dialog.open(CreateProjectsComponent, {
      data: {
        document: document,
        transactionID: core.coreID
      },
      // width: '70vw',
      // height: 'auto',
      panelClass: 'signatureModal',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {
        this.getPDPMCores(this.selectedprocessStageID, this.selectedListType);
      }
    });

  }

  EditForm(document: any, core: any) {
    sessionStorage.setItem('projectID', document.projectID);
    sessionStorage.setItem('type', (ProjectTempType.Project).toString()); // 1 for Project and 2 for Template
    sessionStorage.setItem('ImportTemplateShow', 'true');
    sessionStorage.setItem('MasterTemplatePDFForm', 'false');
    sessionStorage.setItem('MasterTemplateTabularForm', 'false');
    sessionStorage.setItem('MasterOrgTemplatePDFForm', 'false');
    sessionStorage.setItem('MasterTemplateWebForm', 'false');
    this._dataSharingService.sendSelectedProjectName("");
    let links = window.location.href.split(window.location.pathname)[0] + "/esignature/third"
    window.open(links, "_blank");
    sessionStorage.setItem('HeaderModuleName', 'Forms');
    this._dataSharingService.sendSelectedModuleName('Forms');
    this._dataSharingService.sendSelectedFolderContentFromLeftMenu(null);
  }


  FillSelectForm(document: any, core: any) {
    var ReqModel = {
      transactionID: Number(core.coreID),
      documentFolderID: document.documentFolderID,
      taskID: document.taskID,
      formID: document.formID,
      projectID: document.projectID,
      formType: document.formType,
      placeholderID: document.placeholderID,
      fileID: 0,
      databaseID: Number(this.databaseId),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList
    }
    this.loaderService.show();
    this.formsService.autoFillCoreDataintoProject(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.toastr.success('Selected Document filled successfully.', '', {
            timeOut: 3000,
          });
          this.getPDPMCores(this.selectedprocessStageID, this.selectedListType);
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });

  }

  OpenProfile(coreRecord) {
    var getCoreId: any = [];
    var TypeID: any = [];
    getCoreId = coreRecord.filter(x => x.fieldName == "Name");
    if (getCoreId.length > 0) {
      sessionStorage.setItem('transactionID', getCoreId[0].coreID);
    }
    TypeID = coreRecord.filter(x => x.fieldName == "Type");
    if (TypeID.length > 0) {
      sessionStorage.setItem('TypeID', TypeID[0].fieldValue.toString());
    }
    sessionStorage.setItem('moduleName', 'Core');
    window.open('/core/documents', '_blank');
  }




  showDocumentDetails(data: any, core: any) {
    this.selectedDocument = data;
    this.transactionID = core.coreID;
    this.openDocumentDetail = true;
  }

  getClose(closeDetail: boolean) {
    this.openDocumentDetail = closeDetail;
  }


  onFileSelectPlaceHolder(event, selectedFolder, document) {
    if (event.target.files.length > 0) {
      if (event.target.files[0].name.split('.')[0].length > 120) {
        this.toastr.warning('File name upto 120 characters only supported, please rename file.', '', {
          timeOut: 3000,
        });
        return;
      }
      this.UploadFileWithExistingPlaceHolder(document, event.target.files, selectedFolder);
    } else {
      this.selectedFile = '';
      event.target.value = '';
    }
     // ✅ Clear file input to allow re-selection of same file
     event.target.value = '';
  }

  UploadFileWithExistingPlaceHolder(document, uploadDocument, selectedFolder) {
    this.formData = new FormData();
    let files = uploadDocument;//this.uploadFormPlaceHolder.get('uploadDocument').value;
    if (files !== '' && files !== null) {
      var newfilename = files[0].name.replace(/(_\d+(\.\d+)*|\.\d+)+(?=\.pdf$)/g, '');
      let documentType = newfilename.split('.').pop();
      this.formData.append('file', files[0]);
      this.formData.append('DocumentType', documentType);
    } else {
      this.toastr.warning('Please select document');
      return;
    }
    this.formData.append('TransactionID', document.coreID);
    this.formData.append('DocumentFolderID', selectedFolder.documentFolderID);
    this.formData.append('FormID', '0');
    this.formData.append('PlaceholderType', '1');
    this.formData.append('DocumentName', selectedFolder.placeholderName);
    this.formData.append('PlaceholderName', selectedFolder.placeholderName);
    this.formData.append('PlaceholderID', selectedFolder.placeholderID);
    this.formData.append('UserID', this.currentUser.UID);
    this.formData.append('DatabaseID', this.databaseId);
    this.formData.append('OrganizationID', this.organizationId);
    this.formData.append('OfficeID', this.myOfficeID);
    this.loaderService.show();
    this.formsService.AddCoreItemForPlaceholder(this.formData).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.selectedFile = '';
          this.InputFile.nativeElement.value = '';  // ✅ reset input
          this.getPDPMCoresAfterFileUplod(this.selectedprocessStageID, this.selectedListType);
          this.toastr.success('File uploaded successfully.', '', {
            timeOut: 3000,
          });
        }
        else {
          this.InputFile.nativeElement.value = '';  // ✅ reset input
          this.toastr.error('File Upload failed.', '', {
            timeOut: 3000,
          });
          this.loaderService.hide();
        }
      } else {
        this.InputFile.nativeElement.value = '';  // ✅ reset input
        this.loaderService.hide();
      }
    });
  }

  DownloadSigleFile(filename: any, core: any) {
    var ReqModel = {
      transactionID: Number(core.coreID),
      placeholderID: filename.placeholderID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId)
    }
    this.formsService.DownloadCoreDocument(ReqModel).subscribe((response) => {
      if (response != undefined && response.base64URL != null && response.base64URL != undefined) {
        const data = 'data:' + response.contentType + ';base64,' + response.base64URL;
        FileSaver.saveAs(data, response.name);
      } else {
        this.toastr.error('File download failed.', '', {
          timeOut: 3000,
        });
      }
    });
  }

  FillPlaceholderForDocument(document, core: any) {
    return;
    var ReqModel = {
      placeholderID: document.placeholderID,
      UserID: this.currentUser.UID,
      OrganizationID: Number(this.organizationId),
      DatabaseID: Number(this.databaseId)
    }
    this.loaderService.show();
    this.formsService.FillPlaceholder(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          var pdfData = this.responseHolder.data;
          var ProjectName = pdfData.documentName.split('.');
          sessionStorage.removeItem("ProjectName");
          sessionStorage.removeItem("projectID");
          sessionStorage.setItem('ProjectName', ProjectName[0]);
          sessionStorage.setItem('type', (ProjectTempType.Project).toString());
          sessionStorage.setItem('ImportTemplateShow', 'true');
          sessionStorage.setItem('MasterTemplatePDFForm', 'false');
          sessionStorage.setItem('MasterTemplateTabularForm', 'false');
          sessionStorage.setItem('MasterOrgTemplatePDFForm', 'false');
          sessionStorage.setItem('MasterTemplateWebForm', 'false');
          this._dataSharingService.sendSelectedProjectName(ProjectName[0]);
          var ReqModel = {
            Document: pdfData,
            TransactionID: Number(this.transactionID),
            TransactionType: 1, //1 core, 2 Contact, 3 Company
            PlaceholderID: document.placeholderID
          }
          this._dataSharingService.sendFillPlaceholderDocumentForCore(ReqModel);
          //this.router.navigate(['/esignature/first']);
          window.open('/esignature/first', '_blank');
          this.loaderService.hide();
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  openUploadDocumentPopupForAI(task: any, core: any) {
    var getCoreId: any = [] = [];
    var name: string = "";
    getCoreId = core.fields.filter(x => x.fieldName == "Name");
    if (getCoreId.length > 0) {
      name = getCoreId[0].fieldValue;
    }
    const dialogRef = this.dialog.open(UploadAIDocuments, {
      data: {
        transactionID: core.coreID,
        Name: name
      },
      width: '30vw',
      height: 'auto',
      panelClass: 'custom-dialog-container'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {

      }
    });

  }

  getCloseDocumentViewer(closeDetail: boolean) {
    this.openDocumentViewers = closeDetail;
  }

  openPDFViewer(data, core) {
    this.openDocumentViewers = true;
    this.selectedDocument = data;
    this.transactionID = core.coreID;
  }

  startNewSignatureProject() {
    sessionStorage.setItem('MasterTemplatePDFForm', 'false');
    sessionStorage.setItem('type', ("1").toString());
    sessionStorage.removeItem("ProjectName");
    sessionStorage.removeItem("projectID");
    sessionStorage.setItem('ImportTemplateShow', 'true');
    sessionStorage.setItem('MasterOrgTemplatePDFForm', 'false');
    sessionStorage.removeItem('stepCompleted');
    sessionStorage.removeItem('categoryID');
    sessionStorage.setItem('FolderOpenId', '0');
    sessionStorage.setItem('FolderOpenName', '');
    this._dataSharingService.sendSelectedProjectName("");
    sessionStorage.setItem('isSharedWithMeForm', 'false');
    //this.router.navigate(['/esignature/first']);
    window.open('/esignature/first', '_blank');
  }

  quickSignDocument() {

  }

  getPDPMCores(selectedprocessStageID, ListType) {
    this.selectedListType = ListType;
    this.bindTitle(ListType);
    this.roleIdList = [];
    let roles = sessionStorage.getItem('roleIDList').split(',');
    roles.forEach(e => {
      this.roleIdList.push(Number(e));
    });
    var ReqModel = {
      processStageID: selectedprocessStageID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      roleList: this.roleIdList,
      searchKey: this.searchResident,
      PDPMListType: ListType,
      isArchived:this.isArchived
    };
    if (this.runFileAi == false) {
      this.loaderService.show();
    }
    this.formsService.getPDPMCores(ReqModel).subscribe((response) => {
      this.loaderService.hide();
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          if (this.responseHolder.data != null) {
            this.activeMCAResidents = this.responseHolder.data.cores;
            this.medicalStages = this.responseHolder.data.stages;
            if (this.activeMCAResidents == null) {
              this.activeMCAResidents = [];
            }
            if (this.activeMCAResidents.length == 0) {
              this.showNoRecord = true;
            } else {
              this.showNoRecord = false;
            }
            if (this.activeMCAResidents.length > 0) {
              this.activeMCAResidents.forEach(resident => {
                const hasNullBlob = resident.coreDocFolders?.some(folder =>
                  folder.placeholders?.some(placeholder =>
                    placeholder.azureblobPath != null
                  ));
                // Add property to core object
                resident.core.isAI = !!hasNullBlob;
              });
            }
            if (this.activeMCAResidents?.length > 0) {
              this.runFileAi = this.activeMCAResidents?.some(
                resident => resident.core?.isPDPMAIRunning === 1) || false;
            }
          }
        } else {
          this.activeMCAResidents = [];
          this.showNoRecord = true;
          this.loaderService.hide();
        }
      } else {
        this.activeMCAResidents = [];
        this.showNoRecord = true;
        this.loaderService.hide();
      }
    });
  }

  getPDPMCoresAfterFileUplod(selectedprocessStageID, ListType) {
    this.selectedListType = ListType;
    this.bindTitle(ListType);
    this.roleIdList = [];
    let roles = sessionStorage.getItem('roleIDList').split(',');
    roles.forEach(e => {
      this.roleIdList.push(Number(e));
    });
    var ReqModel = {
      processStageID: selectedprocessStageID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      roleList: this.roleIdList,
      searchKey: this.searchResident,
      PDPMListType: ListType,
      isArchived:this.isArchived
    };
      this.loaderService.show();
    this.formsService.getPDPMCores(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          if (this.responseHolder.data != null) {
            this.activeMCAResidents = this.responseHolder.data.cores;
            this.medicalStages = this.responseHolder.data.stages;
            if (this.activeMCAResidents == null) {
              this.activeMCAResidents = [];
            }
            if (this.activeMCAResidents.length == 0) {
              this.showNoRecord = true;
            } else {
              this.showNoRecord = false;
            }
            if (this.activeMCAResidents.length > 0) {
              this.activeMCAResidents.forEach(resident => {
                const hasNullBlob = resident.coreDocFolders?.some(folder =>
                  folder.placeholders?.some(placeholder =>
                    placeholder.azureblobPath != null
                  ));
                // Add property to core object
                resident.core.isAI = !!hasNullBlob;
              });
            }
            if (this.activeMCAResidents?.length > 0) {
              this.runFileAi = this.activeMCAResidents?.some(
                resident => resident.core?.isPDPMAIRunning === 1) || false;
            }
          }
        } else {
          this.activeMCAResidents = [];
          this.showNoRecord = true;
          this.loaderService.hide();
        }
      } else {
        this.activeMCAResidents = [];
        this.showNoRecord = true;
        this.loaderService.hide();
      }
    });
  }

  getPDPMStages() {
    var ReqModel = {
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
    }
    this.taskService.getPDPMStages(ReqModel).subscribe((response) => {
      if (response != undefined) {
        if (response.status == this.statusConstant.statusSuccess && response.data != null) {
          this.stageProcessList = response.data;
        } else {
          this.stageProcessList = [];
        }
      } else {
        this.stageProcessList = [];
      }
    });
  }

  setAlertColor(alertType) {
    let color = "";
    if (alertType == 0) {
      color = "#0f172a";
    }
    else if (alertType == 1) {
      color = "#2e5bff";
    }
    else if (alertType == 2) {
      color = "#eab308";
    }
    else if (alertType == 3) {
      color = "#dc2626";
    }
    return color;
  }

  getShortName(fullName) {
    //return fullName.split(' ').map(n => n[0]).join('');
    return fullName.split(' ').slice(0, 2).map(n => n[0]).join('');
  }

  //======================Core============================//

  searchCore(val) {
    if (val.length >= 1) {
      this.attachedToCoreList = [];
      if (val != '') {
        this.searchName = val;
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.getsearchCore(val)
        }, 500);
      } else {
        this.attachedToCoreList = [];
      }
    }
  }

  getsearchCore(searchValue: any) {
    var SelectedCCC = [];
    SelectedCCC = this.menuModulesList.filter(x => x.mainModuleName == 'Core');
    if (SelectedCCC.length > 0) {
      this.CorefolderID = SelectedCCC[0].folderID;
    }
    this.roleIdList = [];
    let roles = sessionStorage.getItem('roleIDList').split(',');
    roles.forEach(e => {
      this.roleIdList.push(Number(e));
    });

    var ReqModel = {
      roleIDList: this.roleIdList,
      searchKey: searchValue,
      userContactID: Number(sessionStorage.getItem('userContactID')),
      folderID: this.CorefolderID,
      databaseID: Number(this.databaseId),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList
    }
    this.formsService.searchCore(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.attachedToCoreList = response.data;
          // this.attachedToCoreList.push(
          //   {           
          //     "coreID":0,
          //     "name":"Create New",
          //     "email":"",
          //     "imageUrl":"",
          //     "isShared":false,                       
          //     "shortName":""
          // });         
        } else {
          this.attachedToCoreList = [];
        }
      }
    })
  }

  //====== For Add Core  ================//

  coreSelectedNew(coreSelected: any) {
    if (coreSelected.coreID == 0) {
      //this.dialog.closeAll();
      this.addNew('Core');
      return;
    }
    const resident = this.activeMCAResidents.find((res: any) => res.core?.coreID === coreSelected.coreID);
    if (resident) {
      this.stateCtrl.setValue('');
      this.toastr.warning('Selected record already added.', '', {
        timeOut: 3000,
      });
      return;
    } else {

    }
    if (this.addUpdateParticipantList.length > 0) {
      this.stateCtrl.setValue('');
       this.toastr.warning('Only one record is allowed.', '', {
        timeOut: 3000,
      });
      return;
    }
    this.stateCtrl.setValue('');
    var shortName = "";
    shortName = coreSelected.name.match(/\b(\w)/g).join('');

    var obj = {
      name: coreSelected.name,
      email: coreSelected.email,
      coreID: coreSelected.coreID,
      contactID: 0,
      companyID: 0,
      role: 0,
      userID: null,
      typeOfParticipant: 1,
      img: coreSelected.imageUrl,
      shortName: shortName
    }
    this.addUpdateParticipantList.push(obj);
    if (this.addUpdateParticipantList.length > 0) {
      this.showAddButton = false;
    } else {
      this.showAddButton = true;
    }
  }

  mainModuleName: string = "";
  Module: string = "";
  showAddContact: boolean = false;
  showAddCore: boolean = false;
  isShare: boolean = false;
  processStageID: number = 0;


  addNew(module) {
    this.mainModuleName = module;
    var menuModulesList = JSON.parse(sessionStorage.getItem('menuModules'));
    var Module = menuModulesList.filter((x) => x.mainModuleName == module);
    var Modulename = Module[0].orgModuleName;
    this.Module = Modulename;
    this.showAddCore = !this.showAddCore;
  }

  getCloseCore() {
    this.showAddCore = false;
  }

  saveAddNew3C(result) {
    this.addUpdateParticipantList = [];
    this.stateCtrl.setValue('');
    var shortName = "";
    shortName = result.name.match(/\b(\w)/g).join('');
    var objCore = {
      name: result.name,
      email: result.email,
      coreID: result.transactionId,
      contactID: 0,
      companyID: 0,
      role: 0,
      userID: null,
      typeOfParticipant: 1,
      img: result.imageUrl,
      shortName: shortName
    }
    this.addUpdateParticipantList.push(objCore);
    //this.dialogRef.close(this.addUpdateParticipantList);     

  }

  selectStage(stageId: number) {
    this.processStageID = stageId;
  }

  onAddParticipant() {
    if (this.processStageID == 0) {
      this.toastr.warning('Please select process stage.', '', {
        timeOut: 3000,
      });
      return;
    }
    //this.dialogRef.close(this.addUpdateParticipantList);
    var ReqModel = {
      processStageID: this.processStageID,
      coreID: this.addUpdateParticipantList[0].coreID,
      isOverwrite: false,
      userID: this.currentUser.UID,
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID
    }
    //return;
    this.loaderService.show();
    this.formsService.openEpisode(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.dialog.closeAll();
          this.getPDPMCores(0, this.selectedListType);
          this.toastr.success('Participant Added successfully.', '', {
            timeOut: 3000,
          });
          this.showAddButton = false;
          this.loaderService.hide();
        }else{
           this.loaderService.hide();
        }
      }else{
         this.loaderService.hide();
      }
    });
  }

  getCloseCores() {
    this.dialog.closeAll();
    this.showAddButton = true;
    this.addUpdateParticipantList = [];
    this.processStageID = 0;
  }

  OpenEpisode(templateRef: TemplateRef<any>, openFor: string) {
    this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox'
    });
    this.showAddButton = true;
    this.addUpdateParticipantList = [];
    this.stateCtrl.setValue('');
    this.getPDPMStagesList = [];
    this.processStageID = 0;
    this.getPDPMStageslist();
  }

  losDay: number = 0;
  payer: string = "";
  hipps: string = "";
  nursing: string = "";
  careLevel: string = "";
  pt: number = 0;
  ot: number = 0;
  slp: number = 0;
  rate: number = 0;
  selectedcoreID: number = 0;

  openDialogEdit(templateRef: TemplateRef<any>, data: any) {
    this.dialog.open(templateRef, {
      panelClass: 'custom-dialog-container',
      width: '60vw',
      height: 'auto',
    });

    this.selectedcoreID = data.coreID;
    this.losDay = data.coreNTAStats.losDay;
    this.payer = data.coreNTAStats.payer ?? '';
    this.hipps = data.coreNTAStats.hipps ?? '';
    this.nursing = data.coreNTAStats?.nursing ?? '';
    this.careLevel = data.coreNTAStats.careLevel ?? '';
    this.pt = data.coreNTAStats.pt;
    this.ot = data.coreNTAStats.ot;
    this.slp = data.coreNTAStats.slp;
    this.rate = data.coreNTAStats.rate;
    this.losDayCalculation = (data.coreNTAStats.losDayCalculation ?? '').toString();
    this.admissionDate = data.admissionDate;
    this.dischargeDate = data.dischargeDate;
  }


  CoreMedicalStatsUpdate() {
    var ReqModel = {
      coreID: this.selectedcoreID,
      losDay: Number(this.losDay),
      payer: this.payer,
      hipps: this.hipps,
      nursing: this.nursing,
      careLevel: this.careLevel,
      pt: Number(this.pt),
      ot: Number(this.ot),
      slp: Number(this.slp),
      rate: Number(this.rate),
      losDaysCalculationFlag: Number(this.losDayCalculation),
      admissionDate: this.admissionDate,
      dischargeDate: this.dischargeDate,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId),
    };
    this.loaderService.show();
    this.formsService.coreMedicalStatsUpdate(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data == true) {
          this.getPDPMCores(0, this.selectedListType);
          this.toastr.success('Record update successfully.', '', {
            timeOut: 3000,
          });
          this.getCloseCores();
        } else {
          this.loaderService.hide();
          this.toastr.error('Error occurred.', '', {
            timeOut: 3000,
          });
        }
      } else {
        this.loaderService.hide();
        this.toastr.error('Error occurred.', '', {
          timeOut: 3000,
        });
      }
    });
  }

  removeParticipant(item: any) {
    const index = this.addUpdateParticipantList.indexOf(item);
    if (index >= 0) {
      this.addUpdateParticipantList.splice(index, 1);
    }
    if (this.addUpdateParticipantList.length > 0) {
      this.showAddButton = false;
    } else {
      this.showAddButton = true;
    }
  }

  onCheckboxChange(row: any, event: any) {
  if (event.checked) {
    this.selectedItems.push(row);
  } else {
    this.selectedItems = this.selectedItems.filter(x => x.coreID !== row.coreID);
  }
}

  getPDPMStageslist() {
    var ReqModel = {
      categoryID: 0,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId),
    };
    this.formsService.getPDPMStages(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data != null) {
          this.getPDPMStagesList = response.data;
        } else {
          this.getPDPMStagesList = [];
        }
      } else {
        this.getPDPMStagesList = [];
      }
    });
  }

  Search(filterValue) {
    this.searchResident = filterValue.trim();
    this.getPDPMCores(0, this.selectedListType);
  }

  clearFilter() {
    this.searchResident = "";
    this.getPDPMCores(0, this.selectedListType);
  }

  onSelectRow(row: any) {
  if (row.selected) {
    this.selectedRows.push(row);
  } else {
    this.selectedRows = this.selectedRows.filter(r => r !== row);
  }

  this.selectAll = this.activeMCAResidents.length > 0 &&
                   this.activeMCAResidents.every(r => r.selected);
}

toggleAllSelection(event: any) {
  this.selectAll = event.checked;
  this.selectedRows = [];

  this.activeMCAResidents.forEach(row => {
    row.selected = this.selectAll;
    if (this.selectAll) {
      this.selectedRows.push(row);
    }
  });
}


// toggleAll(event: any) {
//   if (event.checked) {
//     this.selectedItems = [...this.activeMCAResidents  ];
//   } else {
//     this.selectedItems = [];
//   }
// }
// isAllSelected(): boolean {
//   return this.selectedItems.length === this.activeMCAResidents.length;
// }
// isSomeSelected(): boolean {
//   return this.selectedItems.length > 0 && this.selectedItems.length < this.activeMCAResidents.length;
// }
// isSelected(row: any): boolean {
//   return this.selectedItems.some(x => x.coreID === row.coreID);
// }


  ProcessNTAGivenDocuments(coreData: any) {
    var ReqModel = {
      coreID: coreData.coreID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
    };
    this.toastr.success('The automation process may take a few minutes. You can continue other tasks on Flowtrics and refresh the list later.', '', {
      timeOut: 8000,
    });
    this.runFileAi=true;
    const resident = this.activeMCAResidents.find(r => r.core?.coreID === coreData.coreID);
    if (resident && resident.core) {
      resident.core.isPDPMAIRunning = 1;
    }
    //this.loaderService.show();
    this.formsService.processNTAOnGivenDocuments(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder == 0) {
          this.toastr.warning('No document found in the MDS folder. Please upload a file.', '', {
            timeOut: 3000,
          });
        }
        if (this.responseHolder == 1) {
          this.toastr.success('The file has been processed successfully.', '', {
            timeOut: 3000,
          });
        }
        // if (this.responseHolder == 2) {
        //   this.toastr.error('Error: Please try again.', '', {
        //     timeOut: 3000,
        //   });
        // }
      } else {
        this.loaderService.hide();
      }
    });
  }


getFirstField(fields: any[], name: string) {
  return fields?.find(f => f.fieldName === name);
}
getNameFields(fields: any[]) {
  return fields?.filter(f => f.fieldName === 'Name') || [];
}
getEmailields(fields: any[]) {
  return fields?.filter(f => f.fieldName === 'Email') || [];
}


ProcessRefreshAI(coreData: any) {
  const ReqModel = {
    coreID: coreData.coreID,
    userID: this.currentUser.UID,
    organizationID: Number(this.organizationId),
    databaseID: Number(this.databaseId),
    officeID: this.myOfficeID,
  };
  this.toastr.info('Refreshing AI status. Please wait...', '', { timeOut: 3000 });
  this.formsService.processRefreshAI(ReqModel).subscribe(
    (response) => {
      if (response?.data) {
        this.toastr.success('AI running status refreshed successfully!', '', { timeOut: 2000 });
          this.getPDPMCores(0, this.selectedListType);
      } else {
        this.toastr.warning(response?.message || 'Unable to refresh AI status.', '', { timeOut: 3000 });
      }
    },
    (error) => {
      this.toastr.error('An error occurred while refreshing AI status.', '', { timeOut: 3000 });
    }
  );
}



  
  confirmDeleteSelected(): void {
  if (!this.selectedRows || this.selectedRows.length === 0) {
    this.toastr.warning('Please select at least one record to delete.', '', { timeOut: 3000 });
    return;
  }

  const message = `Are you sure you want to delete ${this.selectedRows.length} selected record(s)?`;
  const dialogData = new ConfirmDialogModel('Confirm Delete', message, 'Delete');

  const dialogRef = this.dialog.open(ConfirmDialogComponent, {
    panelClass: 'edituserdetails',
    maxWidth: '1000px',
    maxHeight: '500px',
    data: dialogData
  });

  dialogRef.beforeClosed().subscribe(dialogResult => {
    if (dialogResult) {
      const ids = this.selectedRows.map(r => r.core.coreID);
      this.deleteMultipleRecords(ids);
    }
  });
}

archiveSelected(): void {
  // Check if any rows are selected
  if (!this.selectedRows || this.selectedRows.length === 0) {
    this.toastr.warning('Please select at least one episode to archive.', '', { timeOut: 3000 });
    return;
  }

  const message = `Are you sure you want to archive ${this.selectedRows.length} selected episode(s)?`;
  const title = `Confirm Archive`;
  const confirm = `Archive`;

  const dialogData = new ConfirmDialogModel(title, message, confirm);

  const dialogRef = this.dialog.open(ConfirmDialogComponent, {
    panelClass: 'edituserdetails',
    maxWidth: '1000px',
    maxHeight: '500px',
    data: dialogData,
  });

  dialogRef.beforeClosed().subscribe(async (dialogResult) => {
    try {
      if (dialogResult) {
        const selectedIds = this.selectedRows
          .map((r: any) => r?.core?.episodeID)
          .filter((id: any) => !!id);

        if (selectedIds && selectedIds.length > 0) {
          await this.archiveMultiple(selectedIds);
        } else {
          this.toastr.warning('No valid episodes selected for archive.', '', { timeOut: 3000 });
        }
      }
    } catch (e) {
      this.loaderService.hide();
      this.toastr.error('Unexpected error occurred while archiving selected episodes.', '', { timeOut: 3000 });
    }
  });
}

private archiveMultiple(ids: number[]): Promise<void> {
  return new Promise((resolve) => {
    const ReqModel = {
      iDs: ids,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      databaseID: Number(this.databaseId)
    };

    this.loaderService.show();

    this.formsService.archiveEpisodes(ReqModel).subscribe({
      next: (response: any) => {
        this.loaderService.hide();

        if (response && response.status) {
          this.toastr.success('Selected episodes archived successfully.', '', { timeOut: 3000 });
          this.selectedRows=[];
          this.getPDPMCores(0, this.selectedListType);
        } else {
          this.toastr.error('Failed to archive selected episodes.', '', { timeOut: 3000 });
        }

        resolve();
      },
      error: (err) => {
        this.loaderService.hide();       
        this.toastr.error('An error occurred while archiving selected episodes.', '', { timeOut: 3000 });
        resolve();
      }
    });
  });
}

unarchiveSelected(): void {
  if (!this.selectedRows || this.selectedRows.length === 0) {
    this.toastr.warning('Please select at least one record to unarchive.', '', { timeOut: 3000 });
    return;
  }

  const message = `Are you sure you want to unarchive ${this.selectedRows.length} selected record(s)?`;
  const title = `Confirm Unarchive`;
  const confirm = `Unarchive`;

  const dialogData = new ConfirmDialogModel(title, message, confirm);

  const dialogRef = this.dialog.open(ConfirmDialogComponent, {
    panelClass: 'edituserdetails',
    maxWidth: '1000px',
    maxHeight: '500px',
    data: dialogData,
  });

  dialogRef.beforeClosed().subscribe(async (dialogResult) => {
    try {
      if (dialogResult) {
        const selectedIds = this.selectedRows
          .map((r: any) => r?.core?.coreID)
          .filter((id: any) => !!id);

        if (selectedIds && selectedIds.length > 0) {
          await this.unarchiveMultiple(selectedIds);
        } else {
          this.toastr.warning('No valid records selected for unarchive.', '', { timeOut: 3000 });
        }
      }
    } catch (e) {     
      this.loaderService.hide();
      this.toastr.error('Unexpected error occurred while unarchiving selected records.', '', { timeOut: 3000 });
    }
  });
}

private unarchiveMultiple(ids: number[]): Promise<void> {
  return new Promise((resolve) => {
    const ReqModel = {
      iDs: ids,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      databaseID: Number(this.databaseId)
    };

    this.loaderService.show();

    this.formsService.setCoreActivate(ReqModel).subscribe({
      next: (response: any) => {
        this.loaderService.hide();

        if (response && response.status) {
          this.toastr.success('Selected records unarchived successfully.', '', { timeOut: 3000 });
          this.selectedRows=[];
          this.getPDPMCores(0, this.selectedListType);
          
        } else {
          this.toastr.error('Failed to unarchive selected records.', '', { timeOut: 3000 });
        }

        resolve();
      },
      error: (err) => {
        this.loaderService.hide();       
        this.toastr.error('An error occurred while unarchiving selected records.', '', { timeOut: 3000 });
        resolve();
      }
    });
  });
}




deleteMultipleRecords(ids: number[]) {
  const reqModel = {
    coreIDS: ids,
    userID: this.currentUser.UID,
    organizationID: Number(this.organizationId),
    officeID: this.myOfficeID,
    databaseID: Number(this.databaseId)
  };
  this.loaderService.show();
  this.taskService.removeCorefromMedicalCategory(reqModel).subscribe({
    next: (response: any) => {
      this.loaderService.hide();
      if (response && response.status === this.statusConstant.statusSuccess) {
        this.toastr.success('Selected records deleted successfully.', '', { timeOut: 3000 });
        this.getPDPMCores(0, this.selectedListType);
        this.selectedRows=[];
      } else {
        this.toastr.error('Failed to delete selected records.', '', { timeOut: 3000 });
      }
    },
    error: (error) => {
      this.loaderService.hide();
      this.toastr.error('Error occurred while deleting selected records.', '', { timeOut: 3000 });
    }
  });
}

  numberOnly(event: KeyboardEvent): boolean {
    const charCode = event.which ? event.which : event.keyCode;

    // Allow: Backspace, Tab, Delete, Left, Right arrows
    if ([8, 9, 46, 37, 39].includes(charCode)) {
      return true;
    }

    // Allow numbers (0-9)
    if (charCode >= 48 && charCode <= 57) {
      return true;
    }

    // Allow decimal point (.)
    if (charCode === 46) {
      // Prevent more than one decimal point
      const inputValue = (event.target as HTMLInputElement).value;
      if (inputValue.includes('.')) {
        return false;
      }
      return true;
    }

    return false;
  }


  openNTAPopUp(coreData: any) {
    // return;     
    sessionStorage.setItem("transationIdFromPDPM", coreData.coreID);
    const dialogRef = this.dialog.open(NTAComponent, {
      data: {
        transactionID: coreData.coreID,
      },
      panelClass: 'custom-dialog-container',
      width: '100%',
      height: '100%',
      maxWidth: '100vw',
      maxHeight: '100vh',
      hasBackdrop: true,
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {
      }
    });
  }

  closeDialog(result?: any) {
    this.dialogRef.close(result);
  }

  viewNursingText(templateRef: TemplateRef<any>, nta: any) {
    this.nursingText = nta;
    this.dialog.open(templateRef);
  }

  close() {
    this.dialog.closeAll();
  }

  openAttach(folder, coreData: any, ph: any) {
    const dialogRef = this.dialog.open(AttachFilesComponent, {
      data: {
        transactionID: coreData.coreID,
        documentFolderID: ph.documentFolderID,
        placeholderID: ph.placeholderID,
        placeholderName:ph.placeholderName
      },
      width: '30vw',
      height: 'auto',
      panelClass: 'custom-dialog-container'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {
        this.getPDPMCores(0, this.selectedListType);
      }
    });
  }

  ChangeMedicalCategoryForCore(currectProcessStageID: 0, selectedProcessStageID: string, coreID: any, item: any) {
    if (Number(selectedProcessStageID) == 0) {
      this.toastr.warning('Please select pdpm category.', '', {
        timeOut: 3000,
      });
      return;
    }
    if (item.coreProcessStages.length > 0) {
      var checks: any = [] = [];
      checks = item.coreProcessStages.filter(x => x.processStageID == Number(selectedProcessStageID));
      if (checks.length > 0) {
        this.changeStage(selectedProcessStageID, coreID);
        return;
      }
    }
   
    var ReqModel = {
      processStageID: Number(selectedProcessStageID),
      isOverwrite:this.isOverwrite,
      coreID: Number(coreID),
      userId: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
    }
    this.loaderService.show();
    this.formsService.changeMedicalCategoryForCore(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.loaderService.hide();
           this.getPDPMCores(0, this.selectedListType);
          this.toastr.success('pdpm category updated successfully.', '', {
            timeOut: 3000,
          });

        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }
  
 isOverwrite:boolean=true;

 changeStage(selectedProcessStageID, coreID) {
    const message = `Are you sure you want to move to this category? This person was already in this stage earlier, and moving again will regenerate all documents and forms.`;
    const title = `Confirm move`;
    const confirm = `Move`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogChangeComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          var isOverwrite=false;
          if(dialogResult=="WithoutFolder"){
            isOverwrite = false;
          }
          if(dialogResult=="CreateNewFolder"){
            isOverwrite = true;
          }  
          var ReqModel = {
            processStageID: Number(selectedProcessStageID),
            coreID: Number(coreID),
            isOverwrite: isOverwrite,
            userId: this.currentUser.UID,
            organizationID: Number(this.organizationId),
            officeID: this.myOfficeID,
          }
          this.loaderService.show();
          this.formsService.changeMedicalCategoryForCore(ReqModel).subscribe(response => {
            if (response != undefined) {
              this.responseHolder = response;
              if (this.responseHolder.status == this.statusConstant.statusSuccess) {
                this.loaderService.hide();
                this.getPDPMCores(0, this.selectedListType);
                this.toastr.success('pdpm category updated successfully.', '', {
                  timeOut: 3000,
                });
              } else {
                this.loaderService.hide();
              }
            } else {
              this.loaderService.hide();
            }
          });
        }
         this.getPDPMCores(0, this.selectedListType);
      } catch (e) {
        Observable.throw(e);
      }
    });
  }

    mainModuleNameForDetails: string = "Core";
    showDetail: boolean = false;
    vieworUpdate: string = "";
    openFor:string="";

     getCloseDetails(message) {
       this.showDetail = false;
     }

     OpenDetails(core:any,open:any){
       this.openFor=open;
       this.transactionID= Number(core.coreID);
       this.showDetail = true;
     }

    closeColor(){
     this.dialog.closeAll();
   }

    selectedColors(colors:any){   
      var reqModel={
         userID : this.currentUser.UID,
         databaseID : Number(this.databaseId),
         organizationID : Number(this.organizationId),
         coreID : this.deleteList,
         officeID : this.myOfficeID,
         favouriteColorCode : colors,
        }
        const resident = this.activeMCAResidents.find(r => r.core?.coreID === this.selectcoreIdForFav);
        if (resident && resident.core) {
          resident.core.favouriteColorCode = colors;
          resident.core.isFavorite = true;
         }
         this.closeColor();
        //this.loaderService.show();
         this.formsService.FavoriteCoreTransaction(reqModel).subscribe((response) => {
         if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConstant.statusSuccess) {
           // this.loaderService.hide();
           // this.closeColor();
           // this.getPDPMCores(0, this.selectedListType);
          }
        } else {
         // this.closeColor();
         // this.loaderService.hide();
        }
      });
    }  

     selectedImpColors(colors:any){ ;  
        this.currentImportantFavoriteElement.isImportantColorCode = colors;
        this.currentImportantFavoriteElement.isImportant = true;
        this.toastr.success('Marked as important successfully.', '', { timeOut: 3000 });
        this.cdr.markForCheck();
        var reqModel={
         userID : this.currentUser.UID,
         databaseID : Number(this.databaseId),
         organizationID : Number(this.organizationId),
         coreID : this.deleteList,
         officeID : this.myOfficeID,
         favouriteColorCode : colors,
        }
        this.closeColor();
        //this.loaderService.show();
        this.formsService.ImportantCoreTransaction(reqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConstant.statusSuccess) {
           // this.loaderService.hide();          
           // this.getPDPMCores(0, this.selectedListType);
          }
        } else {
          this.closeColor();
          //this.loaderService.hide();
        }
      });
   }  

    deleteList:any=[];
    selectcoreIdForFav:number=0;

    AddRowFavorite(core:any,templateRef: TemplateRef<any>) {
      this.deleteList=[];
      var id = core.coreID;
      this.selectcoreIdForFav = core.coreID;
      this.deleteList.push(id);
      this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox',
     }); 
   }

    AddRowImportant(core:any,templateRef: TemplateRef<any>) {
      this.deleteList=[];
      var id = core.coreID;
      this.deleteList.push(id);
      this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox',
     }); 
      this.currentImportantFavoriteElement = core;
   }


   FavoriteSelectedRecordForDeleteCore(core:any) { 
      var deleteList = [];
      var id = core.coreID;
      deleteList.push(id);

      var reqModel={
        userID : this.currentUser.UID,
        databaseID : Number(this.databaseId),
        organizationID : Number(this.organizationId),
        coreID : deleteList,
        officeID : this.myOfficeID,
      }    
       const resident = this.activeMCAResidents.find(r => r.core?.coreID === core.coreID);
        if (resident && resident.core) {
          resident.core.favouriteColorCode = "";
          resident.core.isFavorite = false;
         }
       //this.loaderService.show(); 
       this.formsService.FavoriteDeleteCoreTransaction(reqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConstant.statusSuccess) {
           // this.loaderService.hide();
           // this.getPDPMCores(0, this.selectedListType);
          }
        } else {
         // this.loaderService.hide();
        }
      });
   } 


    DeleteImportant(core:any) { 
    core.isImportant = false;
    this.toastr.info('Marked as unimportant successfully.', '', { timeOut: 3000 });
      var deleteList = [];
      var id = core.coreID;
      deleteList.push(id);

      var reqModel={
        userID : this.currentUser.UID,
        databaseID : Number(this.databaseId),
        organizationID : Number(this.organizationId),
        coreID : deleteList,
        officeID : this.myOfficeID,
      }    
       //this.loaderService.show(); 
       this.formsService.ImportantDeleteCoreTransaction(reqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          //  this.loaderService.hide();
           // this.getPDPMCores(0, this.selectedListType);
          }
        } else {
          //this.loaderService.hide();
        }
      });
   } 

}
